export const menuData = [
    {title: 'Homes', link: '/homes' },
    {title: 'About', link: '/about' },
    {title: 'Rentals', link: '/rentals' },
    {title: 'Services', link: '/services' },
    {title: 'Team Support', link: '/teamSupport' },

]